"use strict";
const LEGACY_CARRIER_INVOICE_PATH = new RegExp("^(?:\\/index-document-batches\\/\\d+)?\\/loads\\/(?<loadId>\\d+)\\/carrier_invoices\\/(?<id>\\d+)$");
export function carrierInvoiceWorkflowRedirect(path) {
  const [pathname, search] = path.split("?");
  const query = new URLSearchParams(search);
  if (query.has("forceReact")) {
    return null;
  }
  const match = pathname.match(LEGACY_CARRIER_INVOICE_PATH);
  if (!match) {
    return null;
  }
  let target = `/carrier_invoices_workflow/${match.groups.id}?loadId=${match.groups.loadId}`;
  for (const [from, to] of [
    ["emailMessageId", "emailMessageId"],
    ["emailId", "replyEmailId"],
    ["hasMore", "hasMore"]
  ]) {
    const value = query.get(from);
    if (value) {
      target += `&${to}=${encodeURIComponent(value)}`;
    }
  }
  const onDone = query.get("onDone");
  return onDone ? `${target}&onDone=${encodeURIComponent(onDone)}` : target;
}
